import * as AllColors from "../constants/colors";

export function createAccordionMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_PINK500"]] = "pink500";
  obj[AllColors["COLOR_BLUE500"]] = "blue500";
  obj[AllColors["COLOR_YELLOW500"]] = "yellow500";
  obj["default"] = "white";
  return obj;
}
export function createAnchorNavigationMapDefinition() {
  let obj = {};
  return obj;
}
export function createAnswerCardMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "pink";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "brightBlue";
  obj[AllColors["COLOR_DARKBLUE"]] = "darkblue";
  obj[AllColors["COLOR_LIGHT_YELLOW"]] = "whiteOnYellow";
  obj["default"] = "white";
  return obj;
}
export function createBasicTeaserMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_PINK500"]] = "white";
  obj[AllColors["COLOR_BLUE500"]] = "white";
  obj[AllColors["COLOR_BRIGHTBLUE500"]] = "white";
  obj["default"] = "white";
  return obj;
}
export function createBadgeMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "dark";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "dark";
  return obj;
}
export function createBreadcrumbMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "dark";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "dark";
  return obj;
}
export function createBottomDrawerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "pink";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "pink";
  return obj;
}
export function createBulletListMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "dark900";
  obj[AllColors["COLOR_BLUE500"]] = "darkOnBlue";
  obj[AllColors["COLOR_BRIGHTBLUE500"]] = "darkOnBlue";
  obj[AllColors["COLOR_PINK500"]] = "white";
  obj[AllColors["COLOR_PURPLE500"]] = "white";
  obj[AllColors["COLOR_GREEN500"]] = "darkOnGreen";
  obj[AllColors["COLOR_BRIGHTGREEN500"]] = "darkOnGreen";
  obj[AllColors["COLOR_YELLOW500"]] = "dark900";
  obj[AllColors["COLOR_ORANGE500"]] = "dark900";
  obj["default"] = "dark900";
  return obj;
}
export function createBulletListDeprecatedMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "dark";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "dark";
  return obj;
}
export function createBusinesscardAuthorMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "dark";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "dark";
  return obj;
}
export function createBusinesscardContactMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "brightBlue";
  obj[AllColors["COLOR_DARKBLUE"]] = "darkblue";
  obj[AllColors["COLOR_PINK"]] = "pink";
  obj["default"] = "pink";
  return obj;
}
export function createBoxMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_BLUE500"]] = "white";
  obj[AllColors["COLOR_BRIGHTBLUE500"]] = "white";
  obj[AllColors["COLOR_PINK500"]] = "white";
  obj["default"] = "white";
  return obj;
}
export function createButtonMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "pink500";
  obj[AllColors["COLOR_BLUE500"]] = "pink500";
  obj[AllColors["COLOR_BRIGHTBLUE500"]] = "pink500";
  obj[AllColors["COLOR_PINK500"]] = "blue700";
  obj[AllColors["COLOR_PURPLE500"]] = "blue700";
  obj[AllColors["COLOR_GREEN500"]] = "pink500";
  obj[AllColors["COLOR_BRIGHTGREEN500"]] = "pink500";
  obj[AllColors["COLOR_YELLOW500"]] = "pink500";
  obj[AllColors["COLOR_ORANGE500"]] = "pink500";
  obj["default"] = "pink500";
  return obj;
}
export function createCaptionMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "dark900";
  obj[AllColors["COLOR_BLUE500"]] = "dark900";
  obj[AllColors["COLOR_BRIGHTBLUE500"]] = "dark900";
  obj[AllColors["COLOR_PINK500"]] = "white";
  obj["default"] = "dark900";
  return obj;
}
export function createCardTeaserMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "blue500";
  obj[AllColors["COLOR_BLUE500"]] = "brightblue500";
  obj[AllColors["COLOR_BRIGHTBLUE500"]] = "blue500";
  obj[AllColors["COLOR_PINK500"]] = "pink500";
  obj["default"] = "blue500";
  return obj;
}
export function createCarouselMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "pink500";
  obj[AllColors["COLOR_BLUE500"]] = "dark900";
  obj[AllColors["COLOR_BRIGHTBLUE500"]] = "dark900";
  obj[AllColors["COLOR_PINK500"]] = "white";
  obj["default"] = "pink500";
  return obj;
}
export function createCheckboxMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "dark";
  obj[AllColors["COLOR_BLUE500"]] = "dark";
  obj[AllColors["COLOR_BRIGHTBLUE500"]] = "dark";
  obj[AllColors["COLOR_PINK500"]] = "dark";
  obj[AllColors["COLOR_GREEN500"]] = "dark";
  obj[AllColors["COLOR_BRIGHTGREEN500"]] = "dark";
  obj[AllColors["COLOR_YELLOW500"]] = "dark";
  obj[AllColors["COLOR_ORANGE500"]] = "dark";
  obj["default"] = "dark";
  return obj;
}
export function createChipMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "yellow";
  obj["default"] = "yellow";
  return obj;
}
export function createClickableImageMapDefinition() {
  let obj = {};
  obj["default"] = "yellow";
  return obj;
}
export function createColorSeparatorMapDefinition() {
  let obj = {};
  return obj;
}
export function createCompassMapDefinition() {
  let obj = {};
  obj["default"] = "pink";
  return obj;
}
export function createContactBarMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj["default"] = "pink";
  return obj;
}
export function createContactListMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "dark";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "dark";
  return obj;
}
export function createContactLayerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "dark";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj["default"] = "dark";
  return obj;
}
export function createContentAggregatorMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "dark";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "dark";
  return obj;
}
export function createContentAggregatorItemMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "white";
  return obj;
}
export function createContextMenuMapDefinition() {
  let obj = {};
  obj["default"] = "bright";
  return obj;
}
export function createContextMenuItemMapDefinition() {
  let obj = {};
  obj["default"] = "white";
  return obj;
}
export function createDataTableMapDefinition() {
  let obj = {};
  return obj;
}
export function createDateEventMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "dark";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "dark";
  return obj;
}
export function createDatePickerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "white";
  return obj;
}
export function createDividerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_BRIGHT"]] = "dark";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "bright";
  obj[AllColors["COLOR_PINK"]] = "bright";
  obj[AllColors["COLOR_DARKBLUE"]] = "bright";
  obj["default"] = "dark";
  return obj;
}
export function createDropdownMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "white";
  return obj;
}
export function createDropdownOptionMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "white";
  return obj;
}
export function createErrorMessageMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "dark";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj["default"] = "dark";
  return obj;
}
export function createFileUploadMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "dark";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "dark";
  return obj;
}
export function createFilePreviewMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "dark";
  obj[AllColors["COLOR_DARK"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj["default"] = "dark";
  return obj;
}
export function createFooterBarMapDefinition() {
  let obj = {};
  return obj;
}
export function createFormMessageMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "dark";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "dark";
  return obj;
}
export function createHeadlineMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "dark900";
  obj[AllColors["COLOR_BLUE500"]] = "dark900";
  obj[AllColors["COLOR_BRIGHTBLUE500"]] = "dark900";
  obj[AllColors["COLOR_PINK500"]] = "white";
  obj[AllColors["COLOR_PURPLE500"]] = "white";
  obj[AllColors["COLOR_GREEN500"]] = "dark900";
  obj[AllColors["COLOR_BRIGHTGREEN500"]] = "dark900";
  obj[AllColors["COLOR_YELLOW500"]] = "dark900";
  obj[AllColors["COLOR_ORANGE500"]] = "dark900";
  obj["default"] = "dark900";
  return obj;
}
export function createHeadlineBrandMapDefinition() {
  let obj = {};
  obj["default"] = "dark900";
  return obj;
}
export function createIconMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "blue500";
  obj[AllColors["COLOR_BLUE500"]] = "dark900";
  obj[AllColors["COLOR_BRIGHTBLUE500"]] = "dark900";
  obj[AllColors["COLOR_PINK500"]] = "white";
  obj["default"] = "blue500";
  return obj;
}
export function createImageMapDefinition() {
  let obj = {};
  return obj;
}
export function createInfoIconMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "orange500";
  obj[AllColors["COLOR_BLUE500"]] = "white";
  obj[AllColors["COLOR_BRIGHTBLUE500"]] = "white";
  obj[AllColors["COLOR_PINK500"]] = "white";
  obj[AllColors["COLOR_PURPLE500"]] = "white";
  obj[AllColors["COLOR_GREEN500"]] = "white";
  obj[AllColors["COLOR_BRIGHTGREEN500"]] = "white";
  obj[AllColors["COLOR_YELLOW500"]] = "white";
  obj[AllColors["COLOR_ORANGE500"]] = "white";
  obj["default"] = "orange500";
  return obj;
}
export function createInputMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_BLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "white";
  return obj;
}
export function createLinkMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "pink500";
  obj[AllColors["COLOR_BLUE500"]] = "dark";
  obj[AllColors["COLOR_BRIGHTBLUE500"]] = "dark";
  obj[AllColors["COLOR_PINK500"]] = "white";
  obj[AllColors["COLOR_PURPLE500"]] = "white";
  obj[AllColors["COLOR_GREEN500"]] = "dark";
  obj[AllColors["COLOR_BRIGHTGREEN500"]] = "dark";
  obj[AllColors["COLOR_YELLOW500"]] = "dark";
  obj[AllColors["COLOR_ORANGE500"]] = "dark";
  obj["default"] = "pink500";
  return obj;
}
export function createLinklistMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "dark";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "dark";
  return obj;
}
export function createMapMapDefinition() {
  let obj = {};
  return obj;
}
export function createMapInfoLayerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "white";
  return obj;
}
export function createModalMapDefinition() {
  let obj = {};
  return obj;
}
export function createMultiContentStageMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "pink";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj["default"] = "brightBlue";
  return obj;
}
export function createNavigationMapDefinition() {
  let obj = {};
  return obj;
}
export function createNumberMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "dark900";
  obj[AllColors["COLOR_BLUE500"]] = "dark900";
  obj[AllColors["COLOR_BRIGHTBLUE500"]] = "dark900";
  obj[AllColors["COLOR_PINK500"]] = "white";
  obj["default"] = "dark900";
  return obj;
}
export function createOffsetTeaserMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_BLUE500"]] = "white";
  obj[AllColors["COLOR_PINK500"]] = "white";
  obj["default"] = "pink500";
  return obj;
}
export function createOffsetTeaser5MapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "ultralightgrey";
  obj[AllColors["COLOR_DARKBLUE"]] = "brightBlue";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "darkblue";
  obj[AllColors["COLOR_PINK"]] = "darkPink";
  obj["default"] = "ultralightgrey";
  return obj;
}
export function createOptionPickerItemMapDefinition() {
  let obj = {};
  obj["default"] = "pink";
  return obj;
}
export function createPaginationMapDefinition() {
  let obj = {};
  obj["default"] = "yellow";
  return obj;
}
export function createPreloaderCircleMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "pink";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "pink";
  return obj;
}
export function createPreloaderSquaresMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "white";
  return obj;
}
export function createProgressCircleMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "pink";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "pink";
  return obj;
}
export function createPromoFlagMapDefinition() {
  let obj = {};
  obj["default"] = "pink";
  return obj;
}
export function createPageHeaderMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "white";
  return obj;
}
export function createPictogramMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "blue500";
  obj[AllColors["COLOR_BLUE500"]] = "dark900";
  obj[AllColors["COLOR_BRIGHTBLUE500"]] = "dark900";
  obj[AllColors["COLOR_PINK500"]] = "white";
  obj[AllColors["COLOR_PURPLE500"]] = "white";
  obj[AllColors["COLOR_GREEN500"]] = "dark900";
  obj[AllColors["COLOR_BRIGHTGREEN500"]] = "dark900";
  obj[AllColors["COLOR_YELLOW500"]] = "dark900";
  obj[AllColors["COLOR_ORANGE500"]] = "dark900";
  obj["default"] = "blue500";
  return obj;
}
export function createRadioButtonMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "pink500";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "pink500";
  return obj;
}
export function createReadMoreMapDefinition() {
  let obj = {};
  obj["default"] = "darkPink";
  return obj;
}
export function createRteRendererMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "dark900";
  obj[AllColors["COLOR_BLUE500"]] = "dark900";
  obj[AllColors["COLOR_BRIGHTBLUE500"]] = "dark900";
  obj[AllColors["COLOR_PINK500"]] = "white";
  obj[AllColors["COLOR_PURPLE500"]] = "white";
  obj[AllColors["COLOR_GREEN500"]] = "dark900";
  obj[AllColors["COLOR_BRIGHTGREEN500"]] = "dark900";
  obj[AllColors["COLOR_YELLOW500"]] = "dark900";
  obj[AllColors["COLOR_ORANGE500"]] = "dark900";
  obj["default"] = "white";
  return obj;
}
export function createSectionMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_BLUE500"]] = "white";
  obj[AllColors["COLOR_BRIGHTBLUE500"]] = "white";
  obj[AllColors["COLOR_PINK500"]] = "white";
  obj[AllColors["COLOR_PURPLE500"]] = "white";
  obj[AllColors["COLOR_DARK900"]] = "white";
  obj["default"] = "white";
  return obj;
}
export function createSearchResultItemMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "white";
  return obj;
}
export function createSegmentedButtonMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "dark";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "dark";
  return obj;
}
export function createSitelinkMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_DARKBLUE"]] = "darkblue";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "brightBlue";
  obj[AllColors["COLOR_PINK"]] = "pink";
  obj["default"] = "white";
  return obj;
}
export function createSliderMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "pink";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "pink";
  return obj;
}
export function createSwitchToggleMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "pink";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj["default"] = "pink";
  return obj;
}
export function createSpacerMapDefinition() {
  let obj = {};
  return obj;
}
export function createStageMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "white";
  return obj;
}
export function createStepMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "orange500";
  obj[AllColors["COLOR_BLUE500"]] = "orange500";
  obj[AllColors["COLOR_BRIGHTBLUE500"]] = "orange500";
  obj[AllColors["COLOR_PINK500"]] = "orange500";
  obj[AllColors["COLOR_GREEN500"]] = "orange500";
  obj[AllColors["COLOR_BRIGHTGREEN500"]] = "orange500";
  obj[AllColors["COLOR_YELLOW500"]] = "orange500";
  obj[AllColors["COLOR_ORANGE500"]] = "orange500";
  obj["default"] = "orange500";
  return obj;
}
export function createStepsMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "orange500";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "orange500";
  return obj;
}
export function createTableRendererMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_BLUE500"]] = "blue500";
  obj[AllColors["COLOR_BRIGHTBLUE500"]] = "brightblue500";
  obj[AllColors["COLOR_PINK500"]] = "pink500";
  obj["default"] = "white";
  return obj;
}
export function createTabsMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "purple500";
  obj[AllColors["COLOR_PINK"]] = "purple500";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "purple500";
  obj[AllColors["COLOR_DARKBLUE"]] = "purple500";
  obj["default"] = "purple500";
  return obj;
}
export function createTagPillMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "orange500";
  return obj;
}
export function createTextMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "dark900";
  obj[AllColors["COLOR_BLUE500"]] = "dark900";
  obj[AllColors["COLOR_BRIGHTBLUE500"]] = "dark900";
  obj[AllColors["COLOR_PINK500"]] = "white";
  obj[AllColors["COLOR_PURPLE500"]] = "white";
  obj[AllColors["COLOR_GREEN500"]] = "dark900";
  obj[AllColors["COLOR_BRIGHTGREEN500"]] = "dark900";
  obj[AllColors["COLOR_YELLOW500"]] = "dark900";
  obj[AllColors["COLOR_ORANGE500"]] = "dark900";
  obj["default"] = "dark900";
  return obj;
}
export function createTextTeaserMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_PURPLE500"]] = "white";
  obj[AllColors["COLOR_BLUE500"]] = "white";
  obj[AllColors["COLOR_PINK500"]] = "white";
  obj["default"] = "pink500";
  return obj;
}
export function createThirdLevelNavigationMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "pink";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "pink";
  return obj;
}
export function createThirdLevelNavigationItemMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "pink";
  obj[AllColors["COLOR_DARKBLUE"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "pink";
  return obj;
}
export function createTilesTeaserMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_BLUE500"]] = "white";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj[AllColors["COLOR_PINK"]] = "white";
  obj["default"] = "white";
  return obj;
}
export function createTooltipMapDefinition() {
  let obj = {};
  obj["default"] = "white";
  return obj;
}
export function createVideoplayerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "pink500";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "white";
  obj["default"] = "pink500";
  return obj;
}
export function createViolatorMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "pink";
  obj[AllColors["COLOR_DARKBLUE"]] = "darkblue";
  obj[AllColors["COLOR_BRIGHT_BLUE"]] = "brightBlue";
  obj[AllColors["COLOR_PINK"]] = "pink";
  obj["default"] = "pink";
  return obj;
}
export function createWebsiteNavigationMapDefinition() {
  let obj = {};
  return obj;
}
